'use strict';

module.exports = require('./dom-scroll-into-view');


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_dom-scroll-into-view@1.2.1@dom-scroll-into-view/lib/index.js
// module id = 119
// module chunks = 0